import { render, staticRenderFns } from "./u-textarea-outlined-tile.vue?vue&type=template&id=ed5cfdb8&scoped=true&"
import script from "./u-textarea-outlined-tile.vue?vue&type=script&lang=js&"
export * from "./u-textarea-outlined-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5cfdb8",
  null
  
)

export default component.exports